import { isNotEmpty } from 'aos-helpers/src/helpers/FormValidation'

import { TaskTemplate } from '../task'
import { TerminalTask, TerminalTaskType } from '../task/TerminalTask'
import { TaskType } from '../TaskType'
import {
    BaseTaskFormPayload,
    baseTaskFormPayloadFromTask,
    BaseTaskPayloadValidation,
    baseValidateTask,
    initialBaseTaskPayload,
} from './BaseTaskFormPayload'

export interface TerminalTaskFormPayload extends BaseTaskFormPayload {
    type: TaskType.Terminal
    terminalTaskType?: TerminalTaskType
    licensePlate?: string
    vehicleLocation?: string
    paperSupplement?: string
    observation?: string
}

export const terminalTaskFormPayloadFromTask = (
    t: TerminalTask | TaskTemplate<TerminalTask>,
    isClone = false,
): TerminalTaskFormPayload => ({
    type: TaskType.Terminal,
    terminalTaskType: t.terminalTaskType,
    licensePlate: t.licensePlate,
    vehicleLocation: t.vehicleLocation,
    paperSupplement: t.paperSupplement,
    observation: t.observation,
    ...baseTaskFormPayloadFromTask(t, isClone),
})

export interface TerminalTaskPayloadValidation extends BaseTaskPayloadValidation {
    type: TaskType
    terminalTaskType: boolean
    licensePlate?: boolean
}

export const validateTerminalTask = (t: TerminalTaskFormPayload) => ({
    ...baseValidateTask(t),
    terminalTaskType: isNotEmpty(t.terminalTaskType),
    licensePlate:
        t.terminalTaskType === TerminalTaskType.HeatingWires ? isNotEmpty(t.licensePlate) : true,
})

export const initialTerminalTaskPayload: TerminalTaskFormPayload = {
    type: TaskType.Terminal,
    ...initialBaseTaskPayload,
}
